// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.trade-list {
    width: 100%;
    max-width: 90%;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    gap: 20px;
    padding: 20px;
    box-sizing: border-box;
}

/* The header and every trade are separate tables (table-layout: fixed in
   Card.css), so they share these widths to keep the columns aligned:
   narrow # and Re-buys columns leave room for the dates on one line. */
.trade-table th:nth-child(1), .trade-table td:nth-child(1),
.trade-table th:nth-child(5), .trade-table td:nth-child(5) {
    width: 6%;
}
.trade-table th:nth-child(2), .trade-table td:nth-child(2),
.trade-table th:nth-child(6), .trade-table td:nth-child(6) {
    width: 11%;
    white-space: nowrap;
}
`, "",{"version":3,"sources":["webpack://./src/dashboard/components/TradeList.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,cAAc;IACd,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,aAAa;IACb,sBAAsB;AAC1B;;AAEA;;uEAEuE;AACvE;;IAEI,SAAS;AACb;AACA;;IAEI,UAAU;IACV,mBAAmB;AACvB","sourcesContent":[".trade-list {\n    width: 100%;\n    max-width: 90%;\n    margin: 0 auto;\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n    padding: 20px;\n    box-sizing: border-box;\n}\n\n/* The header and every trade are separate tables (table-layout: fixed in\n   Card.css), so they share these widths to keep the columns aligned:\n   narrow # and Re-buys columns leave room for the dates on one line. */\n.trade-table th:nth-child(1), .trade-table td:nth-child(1),\n.trade-table th:nth-child(5), .trade-table td:nth-child(5) {\n    width: 6%;\n}\n.trade-table th:nth-child(2), .trade-table td:nth-child(2),\n.trade-table th:nth-child(6), .trade-table td:nth-child(6) {\n    width: 11%;\n    white-space: nowrap;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
